import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/client/lib/api-client'

export interface InsightItem {
  title: string
  description: string
  metric: string
  metricValue: number
  action: string
  url?: string
  priority: 'high' | 'medium' | 'low'
}

export interface InsightCategory {
  id: string
  label: string
  description: string
  icon: string
  items: InsightItem[]
  count: number
}

export function useInsights(siteId: string) {
  return useQuery({
    queryKey: ['sites', siteId, 'insights'],
    queryFn: () => apiClient.get<{ insights: InsightCategory[]; computedAt: string }>(`/api/sites/${siteId}/insights`),
    enabled: !!siteId,
    staleTime: 30 * 60 * 1000, // 30 min (server caches 1hr)
  })
}
